<template>
	<div class="about">
		<div class="about-info-sec">
			<div class="about-desktop-right">
				<div class="header5">About Us</div>
				<div class="header3">It is your right to have property tax data in a understandable way.</div>
				<div class="paragraph">
					Every taxpayer should have confidence that their property assessment are fair. Garbur’s commitment is to provide the most clear
					and comprehensive picture of your property assessment, and to provide you the tools to appeal unfair assessments. Garbur believes
					it is every taxpayer’s right to have their property assessment presented to them in an understandable way.
				</div>
			</div>
			<div class="image-content"></div>
		</div>
		<div class="about-second-sec">
			<div class="about-contact-content">
				<div class="header3">Contact Us</div>
				<div class="paragraph">Have questions? We have answers! Let us know how can we connect with you.</div>
				<div class="info-cont">
					<div class="contact-us">
						<div>
							<div class="header4">Address</div>
							<div class="header5">1416 Techny Rd<br />Northbrook, IL 60062</div>
						</div>
						<div>
							<div class="header4">Phone</div>
							<div class="header5">847-790-5028<br />info@garbur.com</div>
						</div>
					</div>
					<!-- <div class="footer-socials">
						<img src="/svg/facebook.svg" />
						<img src="/svg/twitter.svg" />
						<img src="/svg/instagram.svg" />
					</div> -->
				</div>
			</div>
			<div class="contact-form">
				<div v-if="!showSendMsg">
					<form class="form-container" action="#">
						<InputBox placeHolder="Full Name" inputStyleType="sharp" type="text" v-model="form.fullName" required />
						<InputBox placeHolder="Phone Number" inputStyleType="sharp" type="tel" v-model="form.phone" required />
						<InputBox placeHolder="Email" inputStyleType="sharp" type="email" v-model="form.email" required />
						<div class="mid-sec">
							<Button title="Submit" :onClick="submit" />
						</div>
					</form>
				</div>
				<div v-else class="thanks-note">
					<div class="header2">Thank You for your request. We will contact you shortly.</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Button from "@/components/ui/Button.vue";
import InputBox from "@/components/ui/InputBox.vue";
import { ABOUT_FORM } from "@/store/constants";

export default {
	title: "Garbur - About Us",
	components: {
		InputBox,
		Button,
	},
	data() {
		return {
			form: {
				fullName: "",
				phone: "",
				email: "",
			},
			showSendMsg: false,
			showToastAlert: false,
		};
	},
	methods: {
		isFormValid() {
			if (!this.form.fullName) {
				return false;
			} else if (!this.form.phone) {
				return false;
			} else if (!this.form.email) {
				return false;
			}
			return true;
		},
		async submit() {
			if (!this.isFormValid()) {
				this.$toast.open({
					message: "Missing form element!",
					position: "top",
					type: "error",
				});
			} else {
				this.showToastAlert = true;
				const aboutForm = {
					fullName: this.form.fullName,
					phone: this.form.phone,
					email: this.form.email,
					garburInfoEmail: "info@garbur.com",
				};
				try {
					const result = await this.$store.dispatch(ABOUT_FORM, aboutForm);
					if (result) this.setAboutFormTrue();
				} catch (ex) {
					this.$toast.open({
						message: "Error happened when submitting about form",
						position: "top",
						type: "error",
					});
				}
			}
		},
		setAboutFormTrue() {
			this.form = {
				fullName: "",
				phone: "",
				email: "",
				garburInfoEmail: "info@garbur.com",
			};
			this.showSendMsg = true;
		},
	},
};
</script>
<style scoped lang="scss">
.about {
	background: var(--white);
	height: 100%;
	padding-bottom: 5vw;
	width: 100%;
	display: flex;
	flex-direction: column;
	.header5 {
		color: var(--accent);
		padding-bottom: 10px;
	}
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--white);
	}
	.image-content {
		content: url(/img/garbor_office.png);
		padding: 40px;
	}
	.about-desktop-right {
		padding-top: 85px;
		padding-left: 45px;
		max-width: 850px;
	}
	.about-info-sec {
		background: var(--dark-blue);
		text-align: left;
		padding: 47px 16px;
		// padding-bottom: 100px;
		display: flex;
		.paragraph {
			margin-top: 30px;
			opacity: 0.5;
			color: var(--white);
		}
	}
	.about-second-sec {
		padding: 47px 16px;
		display: grid;
		grid-gap: 25px;
		grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
	}
	.contact-form {
		padding-top: 85px;
	}
	.about-contact-content {
		display: flex;
		flex-direction: column;
		text-align: left;
		padding-top: 85px;
		max-width: 850px;
		padding-left: 45px;
		.header3 {
			color: var(--black);
		}
		.paragraph {
			margin-top: 25px;
			margin-bottom: 80px;
			opacity: 0.5;
			color: var(--black);
		}
		.info-cont {
			// width: 48%;
			.contact-us {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				width: 75%;
			}
			.footer-socials {
				width: 25%;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
			}
			.header5,
			.header4 {
				color: var(--black);
			}
			.header5 {
				opacity: 0.5;
			}
		}
		.contact-us > div {
			margin-bottom: 35px;
		}
	}
	@media screen and (max-width: 1020px) {
		.about-desktop-right {
			padding-top: unset;
			padding-left: unset;
		}
		.image-content {
			content: "";
			padding: unset;
		}
	}
	@media screen and (max-width: 414px) {
		.about-desktop-right {
			padding-top: unset;
			padding-left: unset;
		}
		.image-content {
			content: "";
			padding: unset;
		}
		.about-second-sec {
			display: grid;
			grid-template-columns: 1fr;
			.about-contact-content {
				padding-left: unset;
			}
			.contact-form {
				padding-top: unset;
			}
		}
		.about-contact-content .info-cont {
			.contact-us {
				width: unset;
			}
			.footer-socials {
				width: 40%;
			}
		}
	}
}
</style>